<template>
  <b-form-group
    label="Teklif Toplam Fiyatı"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Teklif Toplam Fiyatı"
      rules="required"
    >
      <b-input-group append="TL">
        <cleave
          v-model="dataItem.price"
          class="form-control"
          :raw="true"
          :options="options.number"
          placeholder="Giriniz"
          :disabled="itemData.id_confirmed_user !== null || dataItem.id_confirmed_user !== null || itemData.id_purchase_offer_status === '7'"
        />
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
      <!--      <div v-if="itemData.offer_price">-->
      <!--        <small class="text-secondary">-->
      <!--          <feather-icon icon="InfoIcon" />-->
      <!--          Teklif Talebi bütçe tutarı <b>{{ itemData.offer_price |toCurrency }} TL</b> olarak belirlendi.-->
      <!--        </small>-->
      <!--      </div>-->
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import {
  BFormGroup, BInputGroup,
} from 'bootstrap-vue'

export default {
  name: 'PurchaseOfferLinesPrice',
  components: {
    Cleave,
    ValidationProvider,
    BFormGroup,
    BInputGroup,
  },
  data() {
    return {
      required,
      options: {
        number: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['purchaseOfferLines/dataItem']
    },
    itemData() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
